import { TeamEmployee } from "~/components/Team/types";
import { Employee } from "~/models/employee";

export function getEmployeeStatusColor(
  employee: Employee | TeamEmployee | undefined
) {
  return employee?.status === "active" ? "inherit" : "red";
}
